/* MXEDesignz — Gallery page behavior
 * Filter pills + lightbox with keyboard navigation
 */
(function () {
  "use strict";

  function setupFilter() {
    var pills = document.querySelectorAll(".filter-pills .pill");
    var items = document.querySelectorAll(".masonry-item");
    var showingEl = document.getElementById("showing-count");
    if (pills.length === 0 || items.length === 0) return;

    function filter(cat) {
      var visible = 0;
      items.forEach(function (item) {
        var cats = item.dataset.cat || "";
        var show = cat === "all" || cats.split(/\s+/).indexOf(cat) !== -1;
        item.style.display = show ? "" : "none";
        if (show) visible++;
      });
      if (showingEl) showingEl.textContent = visible;
    }

    pills.forEach(function (p) {
      p.addEventListener("click", function () {
        pills.forEach(function (x) { x.classList.remove("active"); });
        p.classList.add("active");
        filter(p.dataset.cat || "all");
      });
    });
  }

  var currentItems = [];
  var lbIdx = 0;

  function showLb() {
    var item = currentItems[lbIdx];
    if (!item) return;
    var kit = document.getElementById("g-lb-kit");
    var rider = document.getElementById("g-lb-rider");
    var bike = document.getElementById("g-lb-bike");
    var imgWrap = document.getElementById("g-lb-img-wrap");
    var orderBtn = document.getElementById("g-lb-order");
    if (kit) kit.textContent = item.dataset.kit || "";
    if (rider) rider.textContent = item.dataset.rider || "";
    if (bike) bike.textContent = item.dataset.bike || "";
    if (imgWrap) {
      var src = item.querySelector("img");
      imgWrap.innerHTML = src ? '<img src="' + src.src + '" alt="">' : '<div class="g-lb-img-ph">📷</div>';
    }
    if (orderBtn) {
      var url = item.dataset.order;
      if (url) { orderBtn.href = url; orderBtn.style.display = ""; }
      else { orderBtn.style.display = "none"; }
    }
  }

  function openLb(el) {
    currentItems = Array.from(document.querySelectorAll('.masonry-item:not([style*="none"])'));
    lbIdx = currentItems.indexOf(el);
    if (lbIdx < 0) return;
    showLb();
    var lb = document.getElementById("g-lb");
    if (lb) { lb.classList.add("open"); document.body.style.overflow = "hidden"; }
  }

  function navLb(dir) {
    if (currentItems.length === 0) return;
    lbIdx = (lbIdx + dir + currentItems.length) % currentItems.length;
    showLb();
  }

  function closeLb() {
    var lb = document.getElementById("g-lb");
    if (lb) { lb.classList.remove("open"); document.body.style.overflow = ""; }
  }

  function setupLightbox() {
    document.querySelectorAll(".masonry-item").forEach(function (item) {
      item.addEventListener("click", function () { openLb(item); });
    });
    var lb = document.getElementById("g-lb");
    if (lb) {
      lb.addEventListener("click", function (e) { if (e.target === lb) closeLb(); });
    }
    var close = document.querySelector(".g-lb-close");
    var prev = document.querySelector(".g-lb-prev");
    var next = document.querySelector(".g-lb-next");
    if (close) close.addEventListener("click", closeLb);
    if (prev) prev.addEventListener("click", function () { navLb(-1); });
    if (next) next.addEventListener("click", function () { navLb(1); });

    document.addEventListener("keydown", function (e) {
      var lb = document.getElementById("g-lb");
      if (!lb || !lb.classList.contains("open")) return;
      if (e.key === "Escape") closeLb();
      if (e.key === "ArrowRight") navLb(1);
      if (e.key === "ArrowLeft") navLb(-1);
    });
  }

  function init() {
    setupFilter();
    setupLightbox();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (!e.target) return;
    if (e.target.querySelector && (e.target.querySelector(".masonry") || e.target.querySelector(".filter-pills"))) {
      init();
    }
  });
})();
